import { DELETE, DELETE_WITH_PARAMS, GET, POST, POST_BLOB, PUT } from "../API";

let source;

export const createMeetingApiCall = (dataObj, onSuccess, onError) => {
  const data = dataObj;
  POST(`/api/v1/meetings/create`, data, onSuccess, onError);
};

export const updateMeetingApiCall = (objData, onSuccess, onError) => {
  const data = objData;
  PUT(`/api/v1/meetings/update`, data, onSuccess, onError);
};

export const regeneratePasscodeApiCall = (meetingId, onSuccess, onError) => {
  PUT(`/api/v1/meetings/regenerate_passcode`, { id: meetingId }, onSuccess, onError);
};

export const createRecurringMeetingApiCall = (dataObj, onSuccess, onError) => {
  POST(`/api/v1/recurring_meetings`, dataObj, onSuccess, onError);
};

export const getRecurringMeetingApiCall = (seriesId, onSuccess, onError) => {
  GET(`/api/v1/recurring_meetings/${seriesId}`, onSuccess, onError);
};

export const updateRecurringMeetingApiCall = (seriesId, dataObj, onSuccess, onError) => {
  PUT(`/api/v1/recurring_meetings/${seriesId}`, dataObj, onSuccess, onError);
};

export const cancelRecurringMeetingApiCall = (seriesId, dataObj, onSuccess, onError) => {
  DELETE_WITH_PARAMS(`/api/v1/recurring_meetings/${seriesId}`, dataObj, onSuccess, onError);
};

export const getAllMeetingsApiCall = ({ dateFrom, dateTo, q } = {}, onSuccess, onError) => {
  const params = new URLSearchParams();
  if (dateFrom) params.append("date_from", dateFrom);
  if (dateTo) params.append("date_to", dateTo);
  if (q) params.append("q", q);

  const queryString = params.toString();
  GET(`/api/v1/meetings${queryString ? `?${queryString}` : ""}`, onSuccess, onError);
};

export const getMeetingsHistoryApiCall = (
  { before, limit, dateFrom, dateTo, q } = {},
  onSuccess,
  onError
) => {
  const params = new URLSearchParams();
  if (before) params.append("before", before);
  if (limit) params.append("limit", limit);
  if (dateFrom) params.append("date_from", dateFrom);
  if (dateTo) params.append("date_to", dateTo);
  if (q) params.append("q", q);

  const queryString = params.toString();
  GET(
    `/api/v1/meetings/history${queryString ? `?${queryString}` : ""}`,
    onSuccess,
    onError
  );
};

export const getMeetingApiCall = (meetingId, onSuccess, onError) => {
  GET(`/api/v1/meetings/${meetingId}`, onSuccess, onError);
};

export const deleteMeetingApiCall = (meetingId, onSuccess, onError) => {
  DELETE(`/api/v1/meetings/${meetingId}`, onSuccess, onError);
};

export const requestToJoinUnauthenticatedApiCall = (
  id,
  name,
  callLanguage,
  chatLanguage,
  onSuccess,
  onError
) => {
  const data = {
    id: id,
    name: name,
    call_language: callLanguage,
    chat_language: chatLanguage,
  };
  POST(
    `/api/v1/meetings/request_to_join_unauthenticated`,
    data,
    onSuccess,
    onError
  );
};

export const cancelRequestToJoinApiCall = (id, onSuccess, onError) => {
  const data = {
    id: id,
  };
  POST(`/api/v1/meetings/cancel_request_to_join`, data, onSuccess, onError);
};

export const requestToJoinAuthenticatedApiCall = (id, onSuccess, onError) => {
  const data = {
    id: id,
  };
  POST(`/api/v1/meetings/request_to_join`, data, onSuccess, onError);
};

export const validateJoinCodeApiCall = (displayId, passcode, onSuccess, onError) => {
  const data = {
    display_id: displayId,
    passcode: passcode,
  };
  POST(`/api/v1/meetings/validate_join_code`, data, onSuccess, onError);
};

export const joinByCodeApiCall = (displayId, passcode, onSuccess, onError) => {
  const data = {
    display_id: displayId,
    passcode: passcode,
  };
  POST(`/api/v1/meetings/join_by_code`, data, onSuccess, onError);
};

export const joinByCodeUnauthenticatedApiCall = (
  displayId,
  passcode,
  name,
  callLanguage,
  chatLanguage,
  onSuccess,
  onError
) => {
  const data = {
    display_id: displayId,
    passcode: passcode,
    name: name,
    call_language: callLanguage,
    chat_language: chatLanguage,
  };
  POST(
    `/api/v1/meetings/join_by_code_unauthenticated`,
    data,
    onSuccess,
    onError
  );
};

export const joinByTokenApiCall = (token, onSuccess, onError) => {
  const data = {
    token: token,
  };
  POST(`/api/v1/meetings/join_by_code`, data, onSuccess, onError);
};

export const joinByTokenUnauthenticatedApiCall = (
  token,
  name,
  callLanguage,
  chatLanguage,
  onSuccess,
  onError
) => {
  const data = {
    token: token,
    name: name,
    call_language: callLanguage,
    chat_language: chatLanguage,
  };
  POST(
    `/api/v1/meetings/join_by_code_unauthenticated`,
    data,
    onSuccess,
    onError
  );
};
